import * as React from "react";
function BalanceLoader() {
  return (
    <div className="w-[100px] rounded-full h-[15px] bg-gray animate-[pulse_0.7s_ease-in-out_infinite]"></div>
  );
}

export default BalanceLoader;
